import { useTranslation } from 'react-i18next';

import { Tile, Title, Content, Header } from 'shared/components/Tile';

import { Content as WidgetContent } from './components/Content';

import type { FC } from 'react';

export const LatestGrades: FC = () => {
  const { t } = useTranslation();

  return (
    <Tile>
      <Header>
        <Title>{t('GSP.pages.dashboard.widgets.latestGrades.title')}</Title>
      </Header>
      <Content>
        <WidgetContent />
      </Content>
    </Tile>
  );
};
